/**
 * The three Reports views: Health (probes, latency, replication backlog),
 * Uploads (what arrived, counted from each center's index) and Studies (what
 * each center holds, by exam type, patient and date, from the per-study
 * catalogue).
 *
 * They are separate pages rather than one page with a toggle because they
 * answer different questions over different records — health samples kept 90
 * days, upload rollups and the study catalogue kept indefinitely — and each
 * has its own filters in the URL. Links, so each view is bookmarkable and Back
 * works.
 */

import { NavLink } from 'react-router-dom';

const TABS = [
  // `end` so /reports is not also "active" while on /reports/uploads.
  { to: '/reports', label: 'Health', end: true },
  { to: '/reports/uploads', label: 'Uploads', end: false },
  { to: '/reports/studies', label: 'Studies', end: false },
] as const;

export function ReportTabs({ className }: { className?: string }) {
  return (
    <nav className={`report-tabs${className ? ` ${className}` : ''}`} aria-label="Reports">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            `report-tabs__link${isActive ? ' report-tabs__link--active' : ''}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
